var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "paymentSlipValidationDetails" },
    [
      _c(
        "el-dialog",
        {
          staticClass: "diglog-card",
          attrs: {
            title: _vm.$t("data.payment_slip_verification_details"),
            visible: _vm.dialogVisible,
            width: "800px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "info-section" }, [
            _c("div", { staticClass: "info-section-title" }, [
              _vm._v(_vm._s(_vm.$t("data.order_basic_info"))),
            ]),
            _c("div", { staticClass: "info-section-body" }, [
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.payment_verification_fee"))),
                ]),
                _c("span", { staticClass: "info-value info-value-amount" }, [
                  _vm._v(
                    "THB " +
                      _vm._s(
                        _vm._f("toDivideWithDot")(
                          _vm.detailData.verification_fee
                        )
                      )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.order_status"))),
                ]),
                _c(
                  "span",
                  { staticClass: "info-value" },
                  [
                    _vm.detailData.order_status
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getOrderStatusType(
                                _vm.detailData.order_status
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getOrderStatusLabel(
                                  _vm.detailData.order_status
                                )
                              )
                            ),
                          ]
                        )
                      : _c("span", [_vm._v("-")]),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.final_verification_result"))),
                ]),
                _c(
                  "span",
                  { staticClass: "info-value" },
                  [
                    _vm.detailData.match_result
                      ? _c(
                          "el-tag",
                          {
                            staticClass: "tag-custom",
                            attrs: {
                              type: _vm.getVerificationResultType(
                                _vm.detailData.match_result
                              ),
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.getVerificationResultLabel(
                                  _vm.detailData.match_result
                                )
                              )
                            ),
                          ]
                        )
                      : _c("span", [_vm._v("-")]),
                  ],
                  1
                ),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("merchantAccount.create_time"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.creation_time || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("merchantAccount.complete_time"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.completion_time || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.merchant_request_order_no"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.merchant_order_id || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.verification_serial_no"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.verification_serial_no || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.mini_qr_full_raw_content"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.mini_qr_raw_content || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.failure_info"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.failure_reason || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.transaction_amount_thb"))),
                ]),
                _vm.detailData.transaction_amount
                  ? _c("span", { staticClass: "info-value" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("toDivideWithDot")(
                            _vm.detailData.transaction_amount
                          )
                        ) + " "
                      ),
                    ])
                  : _c("span", { staticClass: "info-value" }, [_vm._v(" - ")]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.country_code"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.country_code || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.transaction_date"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.transaction_date || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.transaction_time"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.transaction_time || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.transaction_reference_no"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(_vm.detailData.transaction_reference_no || "-")
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.reference_no_1"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.reference_no1 || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.reference_no_2"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.reference_no2 || "-")),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.reference_no_3"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(_vm._s(_vm.detailData.reference_no3 || "-")),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "info-section" }, [
            _c("div", { staticClass: "info-section-title" }, [
              _vm._v(_vm._s(_vm.$t("data.receiver_info"))),
            ]),
            _c("div", { staticClass: "info-section-body" }, [
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.receiving_bank"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(
                        _vm.detailData,
                        "receiver.bank_code"
                      ) || "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.receiver_display_name"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(
                        _vm.detailData,
                        "receiver.display_name"
                      ) || "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.receiver_proxy_type"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(
                        _vm.detailData,
                        "receiver.proxy_type"
                      ) || "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.receiver_proxy_value"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(
                        _vm.detailData,
                        "receiver.proxy_value"
                      ) || "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.receiver_account_type"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(
                        _vm.detailData,
                        "receiver.account_type"
                      ) || "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.receiver_account_no"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(
                        _vm.detailData,
                        "receiver.account_no"
                      ) || "-"
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "info-section" }, [
            _c("div", { staticClass: "info-section-title" }, [
              _vm._v(_vm._s(_vm.$t("data.sender_info"))),
            ]),
            _c("div", { staticClass: "info-section-body" }, [
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.sending_bank"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(_vm.detailData, "sender.bank_code") ||
                        "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.sender_display_name"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(
                        _vm.detailData,
                        "sender.display_name"
                      ) || "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.sender_account_type"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(
                        _vm.detailData,
                        "sender.account_type"
                      ) || "-"
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "info-row" }, [
                _c("span", { staticClass: "info-label" }, [
                  _vm._v(_vm._s(_vm.$t("data.sender_account_no"))),
                ]),
                _c("span", { staticClass: "info-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.getNestedField(_vm.detailData, "sender.account_no") ||
                        "-"
                    )
                  ),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }